import AnalyticsClient, { originType } from '@atlassiansox/analytics-web-client';

import { getEnvType } from '../..';
import { envType } from '../../../common/types';

const isLocal = getEnvType() === envType.LOCAL;

const getApiHost = () => {
	const host = process.env.REMOTE_DOMAIN ? new URL(process.env.REMOTE_DOMAIN).host : '';
	return `${host}/gateway/api/gasv3/api/v1/`;
};

export const devAnalyticsClient = new AnalyticsClient(
	{
		env: getEnvType(),
		locale: 'en',
		product: 'devAgents',
		version: '1.0.0',
		origin: originType.WEB,
	},
	isLocal
		? {
				apiHost: getApiHost(),
			}
		: undefined,
);
